export const accessionCaseTypes = [
  "ORGAN",
  "TISSUE",
  "BIRTH_TISSUE",
  "OCULAR",
] as const;

export type AccessionCaseType = (typeof accessionCaseTypes)[number];

export const accessionCaseTypeLabels: Record<AccessionCaseType, string> = {
  ORGAN: "Organ",
  TISSUE: "Tissue",
  BIRTH_TISSUE: "Birth Tissue",
  OCULAR: "Ocular",
};

export function formatAccessionCaseType(
  caseType: AccessionCaseType | null | undefined,
): string | undefined {
  if (!caseType) {
    return undefined;
  }

  return accessionCaseTypeLabels[caseType];
}
